<div class="map-canvas-box">
    <!-- <div #map class="map-canvas"></div> -->
    <div class="map-canvas">
        <google-map #map="googleMap" height="100%" width="100%" [options]="mapOptions">
            <ng-container *ngFor="let program of allListProgramCoordinates">
                <map-advanced-marker
                    #advancedMarker="mapAdvancedMarker"
                    [position]="program.position"
                    [content]="program.icon"
                    [title]="program.title"
                    (mapClick)="onMarkerClick(advancedMarker, program.windowContent)"
                >
                </map-advanced-marker>
                <map-info-window></map-info-window>
            </ng-container>
        </google-map>
    </div>
</div>
